import { AddressService } from 'ui-utils';
import createResource from './createResource';
import { Facility } from './types';

const facilitiesResource = createResource<Facility>({
  key: 'facilities',
  url: '/facilities',
  processStrategy: (data) => ({
    ...data,
    $address: AddressService.toString(data),
  }),
});

export default facilitiesResource;
